// extracted by mini-css-extract-plugin
export default {"container":"Tag_container__pxHKo","label":"Tag_label__iiu39"};